import React, { useCallback } from 'react'
import styled from 'styled-components'

import useModal from 'hooks/useModal'
import { getTokenURL } from 'lottery/constants'
import Button from 'components/Button'
import WalletProviderModal from 'components/WalletProviderModal'

const GetTokenButton = () => {
  const [onPresentWalletProviderModal] = useModal(
    <WalletProviderModal />,
    'provider'
  )

  const handleUnlockClick = useCallback(() => {
    onPresentWalletProviderModal()
  }, [onPresentWalletProviderModal])

  return (
    <StyledAccountButton>
        <Button href={getTokenURL} size="sm" text="Get UBET Token" />
    </StyledAccountButton>
  )
}

const StyledAccountButton = styled.div``

export default GetTokenButton
